import React, { useEffect } from 'react';
import { Box, Snackbar, Alert, useTheme } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import WorkspaceSidebar, { DRAWER_WIDTH } from './WorkspaceSidebar';
import { hideNotification } from '../../store/actions/uiActions';

const WorkspaceLayout = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const { notification } = useSelector((state) => state.ui);
  const { isAuthenticated, authChecked } = useSelector((state) => state.auth);

  // 未登录用户重定向到landing页面
  useEffect(() => {
    if (authChecked && !isAuthenticated) {
      navigate('/landing');
    }
  }, [authChecked, isAuthenticated, navigate]);

  // 处理通知关闭
  const handleCloseNotification = () => {
    dispatch(hideNotification());
  };

  // 如果未登录，不渲染布局
  if (authChecked && !isAuthenticated) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: 'rgba(228, 228, 228, 0.6)' }}>
      {/* 左侧导航栏 */}
      <WorkspaceSidebar />

      {/* 主内容区域 */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: `calc(100% - ${DRAWER_WIDTH}px)`,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* 内容区域 */}
        <Box
          sx={{
            flex: 1,
            p: { xs: 2, sm: 3, md: 4 },
            overflowY: 'auto',
            '&::-webkit-scrollbar': {
              display: 'none'
            },
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }}
        >
          <Box
            sx={{
              backgroundColor: 'white',
              borderRadius: 3,
              boxShadow: 'none',
              overflow: 'hidden',
              p: { xs: 2, sm: 3 },
              height: '100%',
              maxWidth: '1600px',
              mx: 'auto',
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>

      {/* 全局通知 */}
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        sx={{
          '& .MuiAlert-root': {
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[3],
            py: 1,
            px: 2
          }
        }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.type}
          variant="filled"
          sx={{
            width: '100%',
            alignItems: 'center'
          }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default WorkspaceLayout;